import { Button } from "../../../components/core/basic/Button";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useFetch } from "../../../hooks/api";
import { useAppSelector } from "../../../redux/hooks";
import useInterval from "../../../hooks/useInterval";
import { formatCurrency } from "../../../utils/formatNumber";
import { keepPreviousData, useQueryClient } from "@tanstack/react-query";

const TodayButton = () => {
  const { t } = useTranslation(["merchandising"]);
  const navigate = useNavigate();
  const marketPlace = useAppSelector((state) => state.marketPlace);
  const queryClient = useQueryClient();

  useInterval(() => {
    queryClient.invalidateQueries({
      queryKey: ["merchandise_live_orders"],
    });
    queryClient.invalidateQueries({
      queryKey: ["live_orders_by_hour"],
    });
    queryClient.invalidateQueries({
      queryKey: ["live_ad_spend_report"],
    });
    queryClient.invalidateQueries({
      queryKey: ["live_ad_report"],
    });
    queryClient.invalidateQueries({
      queryKey: ["live_org_report"],
    });
  }, 60000);

  const { data } = useFetch(
    ["merchandise_live_orders", "live_data", marketPlace.marketPlace],
    `/merchandise/live_orders`,
    {
      market_place: marketPlace.marketPlace,
    },
    {
      select: (d) => d.data,
      placeholderData: keepPreviousData,
    },
  );

  return (
    <Button onPress={() => navigate({ to: "/user/live/report" })} colorScheme={"mauve"}>
      {data ?
        t(($) => $.merchandising["Today {amount}"], {
          amount: formatCurrency(data.order_item_value, {
            marketPlace: marketPlace.marketPlace,
            decimalPlaces: 0,
          }),
        })
      : t(($) => $.merchandising["Today"])}
    </Button>
  );
};

export default TodayButton;
